import { api, API_MONO, monolithCache } from '../api/api'

export const getCateringStoresForLocationApi = locationId => {
  return api.get(`${API_MONO}/location/${locationId}/catering-schedule`, null, {
    cache: monolithCache,
  })
}
